module.exports = __webpack_public_path__ + "static/img/4.7832938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news25/4.jpg
// module id = pz6k
// module chunks = 1